import axios from "axios";
import { BACKEND_API } from "../constants";

export const API_HEADERS = {
  "Content-Type": "application/json",
};

export const fetchInformation = (text: string, apiRouterName:string) => {
  return axios.post(
    `${BACKEND_API}/${apiRouterName}` as any,
    {
      message: text,
    },
    {
      headers: API_HEADERS,
    }
  );
};